let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("8gQKz"), load("hhss7"), load("ffEVr"), load("awqCy"), load("kDPsc"), load("1b5ye")]).then(() => parcelRequire('mhFvJ'));